import React, { useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useEffect } from "react";



export const Appointmentchekbox = ({ labelText, options, name, setSkillsdata, id, value, error }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    setSkillsdata(selectedOptions);
  }, [selectedOptions]);

  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };

  // const handleSelectAll = () => {
  //   if (selectedOptions.length === options.length) {
  //     setSelectedOptions([]);
  //   } else {
  //     setSelectedOptions([...options]);
  //   }
  // };

  useEffect(() => {
    if (value) {
      const setop = [];
      const data = value.split(',');
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < options.length; j++) {
          if (data[i] === options[j].id) {
            setop.push({
              id: options[j].id, label: options[j].label
            })
          }
        }
      }
      setSelectedOptions(setop);
    }
  }, [value])


  const handleClearAll = () => {
    setSelectedOptions([]);
  };

  const handleOptionToggle = (option) => {
    setHide(!hide);
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const renderMenu = (results, menuProps) => (
    hide == true &&
    <div className="MultiSelected onMultiSelected mt-2" {...menuProps}>
      <div className="MultiSelectedDrop">
        {results.map((result, index) => (
          <div key={index}>
            <input
              type="checkbox"
              checked={selectedOptions.includes(result)}
              onChange={() => handleOptionToggle(result)}
            />
            <span>{result.label}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
    <div onClick={()=>setHide(!hide)}>
      <label className="form-label inputLable">{labelText}</label>
      <Typeahead
        id="my-typeahead-id3"
        name={name}
        options={options}
        selected={selectedOptions}
        onChange={handleChange}
        placeholder="Select options"
        labelKey="label"
        // dropdownProps={{
        //   style: { maxHeight: "200px", overflow: "auto" },
        // }}
        renderMenu={renderMenu}
      />
      </div>

      {selectedOptions.length > 0 && (
        <button className="btn btn-sm btn-link mt-2" onClick={handleClearAll}>
          X
        </button>
      )}

    </>
  );
};

